import React, { useEffect } from "react"
import { Row, Col, Table } from "react-bootstrap"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"
import {
  updateUiData,
  updateValidFormData,
  getRequiredDocuments,
  getPolicyInfo,
  addBenefitItem,
} from "../redux/actions"
import FormTextbox from "../components/shared/formTextbox"
import FormFieldDisableAutoComplete from "../components/shared/formFieldDisableAutoComplete"
import FormDateInputTextbox from "../components/shared/formDateInputTextbox"
import * as ErrorMessage from "../common/errorMessage"
import * as Constants from "../common/constants"
import { isValid, parse } from "date-fns"
import * as CommonFunction from "../common/function"
import FormMobileTextBox from "../components/shared/formMobileTextBox"
import * as Regex from "../common/regex"
import {
  missingInfoAlert,
  fillSBAccDetailAlert,
  exceedSBAccDetailAlert,
} from "../services/sweetalertService"
import * as API from "../services/httpService"
import { navigate } from "gatsby"

const Index = ({ location }) => {
  const uiData = useSelector(state => state.uiData, shallowEqual)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const dispatch = useDispatch()
  const formRef = React.useRef()
  const [sbAccList, setSbAccList] = React.useState([])

  const addItemToList = values => {
    if (values.SingtelBillAccountNumber && sbAccList.length < 5) {
      let copyOfSbAccList = Object.assign([], sbAccList)
      let index = new Date().getTime().toString()

      copyOfSbAccList.push({
        index: index,
        SingtelBillAccountNumber: values.SingtelBillAccountNumber,
      })

      setSbAccList(copyOfSbAccList)

      formRef.current.setFieldValue("SingtelBillAccountNumber", "")
    } else if (sbAccList.length > 4) {
      exceedSBAccDetailAlert()
    } else {
      fillSBAccDetailAlert()
    }
  }
  const removeItemFromList = index => {
    let copyOfSbAccList = Object.assign([], sbAccList)
    let indexToRemove = copyOfSbAccList.findIndex(x => x.index === index)
    copyOfSbAccList.splice(indexToRemove, 1)
    setSbAccList(copyOfSbAccList)
  }

  useEffect(() => {
    if (uiData.maxPageNumber === 1) {
      const GetDataPromise = API.apiPostRequest("/Claim/GetData", null, null)

      Promise.all([GetDataPromise])
        .then(values => {
          batch(() => {
            if (values[0].data) {
              dispatch(
                updateValidFormData("ClaimSBRTDetailModel", values[0].data)
              )
            }
            dispatch(updateUiData("showLoading", false))
          })
        })
        .catch(error => {
          navigate("errorOccurred")
        })
    } else {
      // Delete all uploaded file
      if (uiData.claimUploadListModel.length > 0) {
        let deleteMultipleFileArray = []

        uiData.claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
          let deleteFileInfo = {}
          deleteFileInfo.fName = UploadedItem.fileName
          deleteFileInfo.folderName = uiData.folderName
          deleteMultipleFileArray.push(deleteFileInfo)
        })

        API.apiPostRequest(
          "/Claim/ClaimDocsMultipleDelete",
          deleteMultipleFileArray,
          null
        ).then(response => {
          dispatch(updateUiData("claimUploadListModel", []))
        })
      }
    }

    CommonFunction.updateUiCurrentPageNumber(dispatch, location.href)
  }, [])

  const formikSchema = Yup.object().shape({
    policyNumber: Yup.string()
      .length(8, ErrorMessage.policyNumber)
      .required(ErrorMessage.policyNumber),
    claimantMobile: Yup.string()
      //.required(ErrorMessage.claimantMobile)
      .matches(Regex.mobilepattern, ErrorMessage.claimantMobile),
    policyHolderNric: Yup.string()
      .required(ErrorMessage.NRIC)
      .matches(Regex.nricpattern, ErrorMessage.NRIC),
    policyHolderName: Yup.string().required(ErrorMessage.policyHolderName),
    claimantEmail: Yup.string()
      .required(ErrorMessage.claimantEmail)
      .email(ErrorMessage.claimantEmail),
    claimantDob: Yup.string()
      //.required(ErrorMessage.employmentDate)
      .test("claimantDob", ErrorMessage.DOB, value => {
        if (value) {
          return isValid(
            parse(value, `d${Constants.sep}M${Constants.sep}yyyy`, new Date())
          )
        } else {
          return true
        }
      })
      .test("claimantDob", ErrorMessage.futureDateErrorMsg, value => {
        if (
          value &&
          isValid(
            parse(value, `d${Constants.sep}M${Constants.sep}yyyy`, new Date())
          )
        ) {
          var dateParts = value.split("/")
          var date = new Date(
            dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0]
          )
          if (dateParts[2].length !== 4) {
            return false
          } else {
            return CommonFunction.notFutureDatime(date, "00:00")
          }
        } else {
          return true
        }
      }),
  })

  const generateFolderName = draftFolderPrefix => {
    let dd = new Date()
    let ss =
      "" +
      dd.getYear() +
      dd.getMonth() +
      dd.getDate() +
      dd.getHours() +
      dd.getMinutes() +
      dd.getSeconds()
    return draftFolderPrefix + ss
  }
  return (
    <Formik
      initialValues={Object.assign({}, claimData["ClaimSBRTDetailModel"])}
      enableReinitialize={true}
      validationSchema={formikSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {
        batch(() => {
          values.claimantName = values.policyHolderName
          values.claimantNric = values.policyHolderNric
          dispatch(updateValidFormData("ClaimSBRTDetailModel", values))

          if (sbAccList.length > 0) {
            dispatch(addBenefitItem("ClaimSBAccountListModel", sbAccList))
          }
          dispatch(getRequiredDocuments(Constants.basicCoverageDetailId))
          dispatch(updateUiData("showLoading", true))
          dispatch(
            updateUiData(
              "folderName",
              generateFolderName(uiData.draftFolderPrefix)
            )
          )

          dispatch(
            getPolicyInfo({
              PolicyNumber: values.policyNumber,
              InsuredNRIC: values.policyHolderNric,
              InsuredName: values.policyHolderName,
              InsuredDOB: values.deceasedDOB,
            })
          )
        })
      }}
    >
      {({ handleSubmit, isSubmitting, isValid, values, errors }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row>
            <div className="title text-center">Retrenchment Claim</div>
            <div className={"containerBody"}>
              {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
              <Field
                textDesc={"Disable Auto Complete"}
                name="disableAutoComplete"
                component={FormFieldDisableAutoComplete}
              />
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="marginBottom16px">
                  <div className={"titleText "}>Policy Information</div>
                </div>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox singleFieldBox"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Enter your policy number"
                    maxLength={20}
                    name="policyNumber"
                    component={FormTextbox}
                  />
                </Col>

                <div className="marginBottom16px marginTop30px">
                  <div className={"titleText "}>Details of Life Assured</div>
                </div>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox topFieldBox mt-3"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Disable Auto Complete"}
                    maxLength={100}
                    name="claimantName"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Name of Life Assured (as per NRIC)"
                    maxLength={100}
                    name="policyHolderName"
                    component={FormTextbox}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Disable Auto Complete"}
                    maxLength={10}
                    name="claimantNricNumber"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="NRIC / FIN No."
                    maxLength={10}
                    name="policyHolderNric"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Date of Birth"
                    name="claimantDob"
                    component={FormDateInputTextbox}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Mobile No"
                    maxLength={8}
                    name="claimantMobile"
                    component={FormTextbox}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Residential Address"
                    maxLength={500}
                    name="claimantResidentialAddress"
                    component={FormTextbox}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Email address"
                    maxLength={100}
                    name="claimantEmail"
                    component={FormTextbox}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox bottomFieldBox"
                >
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete4"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Singtel Bill Account No (Max 5 Entries)"
                    maxLength={100}
                    name="SingtelBillAccountNumber"
                    component={FormTextbox}
                  />
                  <div
                    className="marginTop10px horizontalCenter cursorPointer"
                    role="button"
                    tabIndex="0"
                    onClick={() => {
                      addItemToList(values)
                    }}
                    onKeyDown={() => {
                      addItemToList(values)
                    }}
                  >
                    <Row className="fontSize18px highlight-text fontWeight500">
                      <i
                        className="fa fa-plus-circle marginRight5px"
                        aria-hidden="true"
                      >
                        <p className="displayInline textUnderline">
                          Add Singtel Bill Account Number
                          {/* {sbAccList.length + 1} */}
                        </p>
                      </i>
                    </Row>
                  </div>

                  {sbAccList.length > 0 && (
                    <Table
                      responsive
                      striped
                      bordered
                      hover
                      size="sm"
                      className="marginTop20px"
                    >
                      <thead>
                        <tr>
                          <th>Singtel Bill Account</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sbAccList.map(item => (
                          <tr key={item.index}>
                            <td>{item.SingtelBillAccountNumber}</td>
                            <td>
                              <div
                                className="cursorPointer"
                                role="button"
                                tabIndex="0"
                                onClick={() => {
                                  removeItemFromList(item.index)
                                }}
                                onKeyDown={() => {
                                  removeItemFromList(item.index)
                                }}
                              >
                                <i
                                  className="fa fa-minus-circle marginRight5px"
                                  aria-hidden="true"
                                >
                                  <p className="displayInline textUnderline">
                                    Remove
                                  </p>
                                </i>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </Col>
              </Col>
            </div>
          </Row>
          <Row>
            <div className="submitFormCenterBtnDiv">
              <button
                className="btnSubmitForm fontWeightBold"
                type="submit"
                // disabled={isSubmitting}
              >
                <b>Continue</b>
              </button>
            </div>
          </Row>
          <HandleFormSubmit formRef={formRef} isSubmitting={isSubmitting} />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleFormSubmit = ({ formRef, isSubmitting }) => {
  React.useEffect(() => {
    if (isSubmitting) {
      formRef.current.validateForm().then(errors => {
        if (Object.entries(errors).length !== 0) {
          missingInfoAlert()
          formRef.current.setSubmitting(false)
        }
      })
    }
  }, [isSubmitting])
  return null
}
export default Index
